import styled from 'styled-components';

export const Container = styled.div`
  text-align: left;
  margin: -10px;
  padding: 50px 20px;
  min-height: calc(100vh - 197px);
  background: #FFF;
`;
export const Inner = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;
export const Text = styled.div`
  font-size: 16px;
  color: #000;
  line-height: 1.3em;
`;
export const Text_1 = styled(Text)`
  margin-top: 15px;
`;
export const Title = styled(Text)`
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 40px;
`;
export const SubTitle = styled(Text)`
  font-size: 28px;
  color: #887fff;
  margin-bottom: 15px;
`;
export const Desc = styled(Text)`
  font-size: 16px;
  color: #999;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
`;
export const Desc_1 = styled(Desc)`
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 20px;
`;
export const Link = styled.a`
  font-size: 15px;
  color: #887fff;
  &:hover {
    text-decoration: none;
  }
`;
export const UL = styled.ul`

`;
export const LI = styled.li`
  margin-bottom: 5px;
  line-height: 1.3em;
`;

export default {}
